export enum DownloadLicenseEnum {
    ONLINE = 'online',
    PRINT = 'print',
    SHARE_THIRD_PARTY = 'share-third-party'
}

// Must match the return value of PHP \Salient\Epim\Connectors\PimToTypo3::getMediaGalleryEntry
export interface MediaGalleryAssetType {
    id: string;
    headline: string;
    subline: string;
    description: string;
    copyright: string;
    licenses:  DownloadLicenseEnum[] | null;
    image: string; // url, full resolution
    thumbnail?: string; // url, If not set a placeholder matching the meta_type should be displayed
    meta_type: string;
    meta_filesize: string; // Formatted Filesize
    meta_width?: number; // only for images
    meta_height?: number; // only for images
    meta_dpi?: number; // only for images
    meta_files?: number; // only for archives
    filterValues: {
        [key: string]: string[]
    };
    collected?: boolean;
}
